import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppWrapperComponent } from './navigation/app-wrapper/app-wrapper.component';
import { HomeComponent } from './sections/home-page/home/home.component';
import { ShopComponent } from 'src/shop-manager/sections/home-page/shop/shop.component';
import { PatientManagerComponent } from 'src/patient-manager/sections/patient-manager/patient-manager.component';

const routes: Routes = [
  {
    path: ``,
    component: AppWrapperComponent,
    // canActivate: [AuthGuard],
    // data: {
    //   roles: [Roles.hcp]
    // },
    children:
    [
      {
        path: ``,
        pathMatch: 'full',
        component: HomeComponent
      },
      {
        path: `shopManager`,
        pathMatch: 'full',
        component: ShopComponent
      },
      {
        path: `patientManager`,
        pathMatch: 'full',
        component: PatientManagerComponent
      }
    ]
  }]

@NgModule({
   imports: [RouterModule.forRoot(routes,{
  paramsInheritanceStrategy: 'always'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
